import React from 'react'
import { Controller, useForm, useWatch } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { Button } from 'ui'
import { Input, Select } from 'ui/fields'
import { partnerProfilePMS } from '../../../../api/partner'
export type Inputs = {
   profileSourceId: string
   pmsSystem: string
   subtype: string
}
type Props = {
   defautlValues?: partnerProfilePMS[]
   onSubmit: (data: Inputs) => void
   isLoadingSubmit: boolean
}
function ProfilesPMSForm(props: Props) {
   const { defautlValues, onSubmit, isLoadingSubmit } = props
   const intl = useIntl()

   const {
      register,
      handleSubmit,
      control,
      formState: { errors, dirtyFields },
   } = useForm<Inputs>({
      mode: 'onChange',
   })
   const validateOptions = (type: string) => {
      if (type !== 'OperaOWSCloud') return defautlValues?.some((profile) => profile.pmsSystem === type)
      return (
         defautlValues?.some((profile) => profile.pmsSystem === type && profile.subtype === 'GUEST') &&
         defautlValues?.some((profile) => profile.pmsSystem === type && profile.subtype === 'SOURCE')
      )
   }
   const validatesubTypeOptions = (type: string) => {
      return defautlValues?.some((profile) => profile.subtype === type)
   }
   const pmsSystemSelected = useWatch({ control, name: 'pmsSystem' })
   const showSubType = pmsSystemSelected === 'OperaOWSCloud'
   return (
      <div className="flex flex-col gap-y-4 mx-4 mb-6">
         <h3>{intl.formatMessage({ id: 'partner.form.profilePMS.title' })}</h3>
         <form onSubmit={handleSubmit(onSubmit)} className="w-full">
            <div className="flex space-x-5 w-full items-end justify-center items-start">
               <Input
                  type="number"
                  autoFocus
                  label={intl.formatMessage({ id: `partner.form.profilePMS.id` })}
                  {...register('profileSourceId', {
                     required: intl.formatMessage({ id: `partner.form.profilePMS.error.id` }),
                  })}
                  boldLabel={false}
                  error={errors?.profileSourceId?.message}
                  isTouched={dirtyFields.profileSourceId}
                  containerClassName="w-full text-gray-700"
               />
               <Controller
                  name={`pmsSystem`}
                  control={control}
                  rules={{
                     required: intl.formatMessage({ id: 'partner.form.profilePMS.error.type' }),
                     validate: (value) => {
                        return value ? true : intl.formatMessage({ id: 'partner.form.profilePMS.error.type' })
                     },
                  }}
                  render={({ field: { value, onChange } }) => (
                     <Select
                        label={intl.formatMessage({ id: `partner.form.profilePMS.type` })}
                        value={value || ''}
                        onChange={(i: string) => {
                           onChange(i)
                        }}
                        error={errors?.pmsSystem?.message}
                        showErrorText={true}
                        className="w-full text-gray-700"
                        boldLabel={false}
                        isTouched={dirtyFields.pmsSystem}
                     >
                        <Select.Option value="">Seleccionar</Select.Option>
                        {['OperaOWS', 'Shiji', 'OperaOWSCloud'].map((type) => (
                           <Select.Option key={type} value={type} disabled={validateOptions(type)}>
                              {type}
                           </Select.Option>
                        ))}
                     </Select>
                  )}
               />
               {showSubType && (
                  <Controller
                     name={'subtype'}
                     control={control}
                     rules={{
                        required: intl.formatMessage({ id: 'partner.form.profilePMS.error.subType' }),
                        validate: (value) => {
                           return value ? true : intl.formatMessage({ id: 'partner.form.profilePMS.error.subType' })
                        },
                     }}
                     render={({ field: { value, onChange } }) => (
                        <Select
                           label={intl.formatMessage({ id: `partner.form.profilePMS.subType` })}
                           value={value || ''}
                           onChange={(i: string) => {
                              onChange(i)
                           }}
                           error={errors?.subtype?.message}
                           showErrorText={true}
                           className="w-full text-gray-700"
                           boldLabel={false}
                           isTouched={dirtyFields.subtype}
                        >
                           <Select.Option value="">Seleccionar</Select.Option>
                           {['GUEST', 'SOURCE'].map((type) => (
                              <Select.Option key={type} value={type} disabled={validatesubTypeOptions(type)}>
                                 {type}
                              </Select.Option>
                           ))}
                        </Select>
                     )}
                  />
               )}
               <Button
                  type="submit"
                  bsStyle="default"
                  buttonStyle={{
                     paddingRight: '25px',
                     paddingLeft: '25px',
                     color: 'white',
                     backgroundColor: 'rgb(217 119 6 / var(--tw-bg-opacity))',
                  }}
                  disabled={isLoadingSubmit}
               >
                  Capturar
               </Button>
            </div>
         </form>
      </div>
   )
}

export default ProfilesPMSForm
